import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const GrievanceDetails = ({ handleClose, customDetails, fiuInfo }) => {
	const theme = useTheme();
	const isDark = customDetails?.darkTheme === true || theme.palette.mode === 'dark';

	// Check if fiuEmail exists in fiuInfo
	const showDhanaprayoga = fiuInfo?.email || fiuInfo?.fiuEmail;

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
			<Typography
				sx={{
					fontSize: '0.875rem',
					lineHeight: '1.5',
					color: isDark ? '#FFFFFF' : '#6C6C6C',
				}}
			>
				For grievances related to Finvu AA, please contact{' '}
				<Typography
					component="a"
					href="mailto:grievance@cookiejar.co.in"
					sx={{
						color: isDark ? '#FFFFFF' : '#6C6C6C',
						textDecoration: 'none',
						'&:hover': {
							textDecoration: 'underline',
						},
					}}
				>
					grievance@cookiejar.co.in
				</Typography>
				.
			</Typography>
			{showDhanaprayoga && (
				<Typography
					sx={{
						fontSize: '0.875rem',
						lineHeight: '1.5',
						color: isDark ? '#FFFFFF' : '#6C6C6C',
					}}
				>
					For grievances related to Dhanaprayoga, please contact{' '}
					<Typography
						component="a"
						href="mailto:support@dhanaprayoga.com"
						sx={{
							color: isDark ? '#FFFFFF' : '#6C6C6C',
							textDecoration: 'none',
							'&:hover': {
								textDecoration: 'underline',
							},
						}}
					>
						support@dhanaprayoga.com
					</Typography>
					.
				</Typography>
			)}
		</Box>
	);
};

export default GrievanceDetails;
